var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsPinnedContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.62,
    height: 16.992,
    viewBox: "0 0 27.62 16.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinned_contacts",
    "data-name": "pinned contacts",
    transform: "translate(-763.408 -991.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people-outline",
    transform: "translate(763.911 992.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M276.4,99.6a3.311,3.311,0,1,1-6.6,0,3.311,3.311,0,1,1,6.6,0Z",
    transform: "translate(-257.905 -96)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M199.2,304c-3.257,0-6.389,1.618-7.173,4.768a.635.635,0,0,0,.586.829h13.176a.636.636,0,0,0,.586-.829C205.59,305.567,202.458,304,199.2,304Z",
    transform: "translate(-184.007 -293.605)",
    fill: "none",
    stroke: "#3e5172",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M99.14,130.9a2.66,2.66,0,1,1-5.3,0,2.659,2.659,0,1,1,5.3,0Z",
    transform: "translate(-90.744 -126.401)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M40.686,295.122a7,7,0,0,0-2.949-.572c-2.6,0-5.1,1.292-5.73,3.808a.508.508,0,0,0,.468.662h5.611",
    transform: "translate(-31.99 -284.627)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "pin-outline",
    transform: "translate(683.204 832.338) rotate(48)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.934,
    cy: 1.934,
    r: 1.934,
    transform: "translate(191.756 32)",
    fill: "#3e5172",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M240,155.16c0-.088.112-.16.25-.16h.389c.138,0,.25.072.25.16v5.225a.4.4,0,0,1-.069.22l-.28.427a.144.144,0,0,1-.191,0l-.28-.427a.4.4,0,0,1-.069-.22Z",
    transform: "translate(-46.754 -118.907)",
    fill: "#3e5172"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsPinnedContactsIcon);
export default __webpack_public_path__ + "static/media/settings-pinned-contacts-icon.f89512421562e44aa1de186cbe08eb2f.svg";
export { ForwardRef as ReactComponent };